<template>
  <input
    v-model="value"
    :placeholder="placeholder"
    :class="{
      'border border-gray-300 dark:border-input-border-dark': border,
    }"
    class="w-full rounded-xl bg-transparent p-3 placeholder:text-sm focus-within:ring-primary-button focus-visible:outline-none focus-visible:ring-2"
  />
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: string;
  border?: boolean;
  placeholder?: string;
}>();
const emit = defineEmits<{
  (e: "update:modelValue", value: string | number): void;
}>();

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>
